import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import type { PortfolioStatus } from "../../utils/portfolioIntelligenceUtils";

function scoreColor(status: PortfolioStatus): string {
  switch (status) {
    case "duplicate":
      return "error.main";
    case "review":
      return "warning.main";
    default:
      return "success.main";
  }
}

interface DuplicateScoreBarProps {
  score: number;
  status: PortfolioStatus;
}

const DuplicateScoreBar: React.FC<DuplicateScoreBarProps> = ({ score, status }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 120 }}>
      <LinearProgress
        variant="determinate"
        value={score}
        sx={{
          flex: 1,
          height: 6,
          borderRadius: 999,
          bgcolor: "action.hover",
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            bgcolor: scoreColor(status),
          },
        }}
      />
      <Typography variant="body2" fontWeight={600} sx={{ minWidth: 36 }}>
        {score}%
      </Typography>
    </Box>
  );
};

export default DuplicateScoreBar;
